export const APPLICANT_RESPONSIBLE_MANAGER_FIELD_NAME = 'responsible_manager'

export const QA_NAME_APPLICANT_RESPONSIBLE_MANAGER_MODAL =
  'applicantResponsibleManagerModal'

export const QA_NAME_APPLICANT_RESPONSIBLE_MANAGER_SELECT =
  'applicantResponsibleManagerSelect'
